import { z } from "zod";

/**
 * Herald chat catalog definition for inline text links. Use in renderer catalog.
 * Renders as primary-colored, underlined xs text; opens http(s) URLs in a new tab.
 */
export const ChatLinkSpec = {
  props: z.object({
    text: z.string(),
    href: z.string(),
  }),
  description: "External link that opens in a new tab.",
  example: {
    text: "View docs",
    href: "https://example.com",
  },
} as const;

const isHttpUrl = (href: string) =>
  href.startsWith("http://") || href.startsWith("https://");

/**
 * Adapter for json-render defineRegistry: renders a styled anchor for Herald specs.
 */
export const ChatLinkFromProps = ({
  props,
}: {
  props: Record<string, unknown>;
}) => {
  const { text, href } = props as { text: string; href: string };
  const className = "text-primary text-sm underline";

  if (typeof href === "string" && isHttpUrl(href)) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {text}
      </a>
    );
  }

  return <span className={className}>{text}</span>;
};
